import React from 'react';

import { green } from '../../Utils/styleConstants';
import { getInTarifsState } from '../../Utils/storeHelpers';
import TarifRecapOption from "./TarifRecapOptions";


const PackGestionLocativeOskarRecap = ({ oskarOffer }) => {
    const tarifsData = [
        { label: 'De 1 à 25 lots', tarif: getInTarifsState('oskar-value-range-0-display') },
        { label: 'De 26 à 100 lots', tarif: getInTarifsState('oskar-value-range-1-display') },
        { label: 'De 101 à 200 lots', tarif: getInTarifsState('oskar-value-range-2-display') },
        { label: 'De 201 à 500 lots', tarif: getInTarifsState('oskar-value-range-3-display') },
        { label: 'De 500 lots à plus', tarif: getInTarifsState('oskar-value-range-4-display') },
    ];

    const rows = tarifsData.map((item) => {
        const priceValue = item.tarif.price[oskarOffer];
        const isIncluded = priceValue === 0;

        return {
            label: item.label,
            labelNormalWeight: true,
            prices: [
                {
                    value: isIncluded ? 'inclus' : priceValue.toFixed(2),
                    color: green,
                    unit: isIncluded ? null : `HT ${item.tarif.priceUnit}`,
                },
            ],
        };
    });

    return (
        <TarifRecapOption
            title="Frais par lot"
            rows={rows}
            withColumnBackground
            withColumnBorder
        />
    );
};

export default PackGestionLocativeOskarRecap;